export default __webpack_public_path__ + "static/media/THETA.c7b71c71.png";